import React from "react";
import { useNavigate } from "react-router-dom";
import Fab from "../ui/Fab";

const AddDailyReport = () => {
  const navigate = useNavigate();
  return <Fab onClick={() => navigate("/daily-reports/new")} label="Νέος απολογισμός" />;
};

export default AddDailyReport;
